import { TokenInfo } from "./ao/token"
import { OrderType } from "./components/swap/types/swap-types"
import ENV from "./env"

export type TimeoutConfig = {
  maxTries: number
  initialDelay: number
}

export const QUICK_OPERATION: TimeoutConfig = {
  maxTries: 5,
  initialDelay: 1_000,
}

export const NORMAL_OPERATION: TimeoutConfig = {
  maxTries: 1000,
  initialDelay: 2_000,
}

export const LONG_OPERATION: TimeoutConfig = {
  maxTries: 1000,
  initialDelay: 3_000,
}

/**
 * @deprecated use LONG_OPERATION instead
 */
export const INITIAL_DELAY = 4_000
/**
 * @deprecated use LONG_OPERATION instead
 */
export const RETRY_INTERVAL = 3_000
/**
 * @deprecated use LONG_OPERATION instead
 */
export const MAX_TRIES = 10

export const RECENT_ACTIVITY = 5
export const SNACKBAR_TIMEOUT = 10_000

export const REFRESH_INTERVAL = 15_000
export const REFRESH_INTERVAL_QUICK = 2_000

export const DEXI = ENV.VITE_DEXI_PROCESS
export const TOKENDROP_REGISTRY = ENV.VITE_TOKEN_FACTORY_PROCESS
export const AGENTS_FACTORY = ENV.VITE_AGENT_FACTORY_PROCESS
export const AMM_FACTORY = ENV.VITE_AMM_FACTORY_PROCESS

// Timestamp of the last factory reset
export const HISTORY_CUTOFF = Number(ENV.VITE_HISTORY_CUTOFF)

const MOCKAO = ENV.VITE_MOCKAO
const AO = "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc"

export const NONTRANSFERABLE_TOKENS: string[] = ["aYrCboXVSl1AXL9gPFe3tfRxRf0ZmkOXH65mKT0HHZw"]

export const VERIFIED_TOKENS = [MOCKAO]

export const W_AR: TokenInfo = {
  id: "xU9zFkq3X2ZQ6olwNVvr1vUWIjc3kXTWr7xKQD6dh10",
  name: "Wrapped AR",
  ticker: "wAR", // patched
  denomination: 12,
  logo: "L99jaxRKQKJt9CqoJtPaieGPEhJD3wNhR4iGqc8amXs",
}

const Q_AR: TokenInfo = {
  id: "NG-0lVX882MG5nhARrSzyprEK6ejonHpdUmaaMPsHE8",
  denomination: 12,
  ticker: "qAR",
  logo: "26yDr08SuwvNQ4VnhAfV4IjJcOOlQ4tAQLc1ggrCPu0",
  name: "Q Arweave",
}

const AO_TOKEN: TokenInfo = {
  id: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
  ticker: "AO",
  denomination: 12,
  logo: "UkS-mdoiG8hcAClhKK8ch4ZhEzla0mCPDOix9hpdSFE",
  name: "AO",
}

const USDA: TokenInfo = {
  id: "FBt9A5GA_KXMMSxA2DJ0xZbAq8sLLU2ak-YJe9zDvg8",
  ticker: "USDA",
  denomination: 12,
  logo: "seXozJrsP0OgI0gvAnr8zmfxiHHb5iSlI9wMI8SdamE",
  name: "Astro USD",
}

export const COMMON_TOKEN_CHOICES: TokenInfo[] = [AO_TOKEN, W_AR, USDA]

// export const DEFAULT_SELL_TOKEN_ID = COMMON_TOKEN_CHOICES[0]?.id

export const FORMAT_DECIMALS = 3
export const INPUT_DECIMALS = 6
export const PRICE_DECIMALS = 18

export const COMMON_QUOTE_TOKENS: string[] = [W_AR.id, AO_TOKEN.id]

export const TOKEN_INFO_TIMEOUT = 5000
export const TOKEN_BALANCE_TIMEOUT = 99999999999999 //5000
export const NO_TIMEOUT = 99999999999999

export const BLACKLIST: string[] = [
  // "agYcCFJtrMG6cqMuZfskIkFTGvUPddICmtQSBIoPdiA", // arns ar io registry
  // "OT9qTE2467gcozb2g8R6D6N3nQS94ENcaAIJfUzHCww", // trunk
]

export const TOKEN_MIRRORS: Record<string, string> = {
  [AO]: "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc",
}

export const HELP_LINKS: Record<OrderType, string> = {
  swap: "https://docs.autonomous.finance/products/platforms/botega/swap-assets-and-run-agents/how-to-do-a-simple-swap",
  limit:
    "https://docs.autonomous.finance/products/platforms/botega/swap-assets-and-run-agents/limit-orders-agents",
  dca: "https://docs.autonomous.finance/products/platforms/botega/swap-assets-and-run-agents/dca-dollar-cost-averaging-agents",
  "stop-loss":
    "https://docs.autonomous.finance/products/platforms/botega/swap-assets-and-run-agents/stop-loss-order-agents",
}

export const HELP_LINK_TOOLTIPS: Record<OrderType, string> = {
  swap: "How to do a simple Swap",
  dca: "How to use the DCA Orders",
  limit: "How to use the Limit Orders",
  "stop-loss": "How to use the Stop Loss Orders",
}

export const DAI: TokenInfo = {
  id: "0x6b175474e89094c44da98b954eedeac495271d0f",
  denomination: 18,
  logo: "uulB-ieOGe2UtWgcVewq0xjp-HBZr_78kvHNr742ZuQ",
  name: "Dai",
  ticker: "DAI",
}

export const stETH: TokenInfo = {
  id: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
  denomination: 18,
  logo: "5fRrV3CmIaq4T2S__5A_4s3TK4tWLXhgvwJBuFkuptc",
  name: "stETH",
  ticker: "stETH",
}

export const AUTONOMOUS_FINANCE_ADDRESS = "yqRGaljOLb2IvKkYVa87Wdcc8m_4w6FI58Gej05gorA"

export const DELEGATE_PROCESS = "cuxSKjGJ-WDB9PzSkVkVVrIBSh3DrYHYz44usQOj5yE"
export const BOTEGA_PROJECT_ADDRESS = "UcBPqkaVI7W4I_YMznrt2JUoyc_7TScCdZWOOSBvMSU"
